import React from "react";
import PropTypes from "prop-types";
import classnames from "classnames/bind";

import Icon from "@components/icon";

import styles from "./ScenarioStatus.scss";

const cx = classnames.bind(styles);

const types = {
  success: "ic_success",
  error: "ic_error",
};

const ScenarioStatus = ({ children, type, className }) => (
  <div className={cx("status", className)}>
    {!!types[type] && <Icon name={types[type]} size="l" />}

    <div className={cx("content", types[type] && type)}>{children}</div>
  </div>
);

ScenarioStatus.propTypes = {
  children: PropTypes.node,
  type: PropTypes.oneOf(["success", "error"]),
  className: PropTypes.string,
};

export default ScenarioStatus;
